import { asThemedDarkSvg, asThemedSvg } from '../../hocs';
import SidebarCapSvg from './SidebarCapSvg';

const ThemedSidebarCapSvg = asThemedSvg(SidebarCapSvg);
const ThemedDarkSidebarCapSvg = asThemedDarkSvg(SidebarCapSvg);

export default SidebarCapSvg;
export { SidebarCapSvg, ThemedSidebarCapSvg, ThemedDarkSidebarCapSvg };
